import { type AnyAction, combineReducers } from 'redux';

import type { TabDurationStore } from 'js/src/data/analytics';
import {
    initializeTabDurations,
    syncDurationForTab,
} from 'js/src/data/analytics/analytics-actions';
import { EDITOR_TAB_OPTIONS } from 'js/src/data/app/app-types';
import { ImmutableFromJS } from 'js/src/libs/consts';
import TimeTracker from 'js/src/libs/TimeTracker';

const time_tracker = new TimeTracker(0);

export function initial_store_state(): TabDurationStore {
    return ImmutableFromJS({
        media_tab_duration: 0,
        music_tab_duration: 0,
        style_tab_duration: 0,
        format_tab_duration: 0,
        icons_tab_duration: 0,
        voiceover_tab_duration: 0,
        original_content_tab_duration: 0,
    }) as TabDurationStore;
}

export function tab_durations(state: TabDurationStore = initial_store_state(), action: AnyAction) {
    if (initializeTabDurations.match(action)) {
        state = state.set('media_tab_duration', action.payload.media ?? 0);
        state = state.set('music_tab_duration', action.payload.music ?? 0);
        state = state.set('style_tab_duration', action.payload.style ?? 0);
        state = state.set('format_tab_duration', action.payload.format ?? 0);
        state = state.set('icons_tab_duration', action.payload.icons ?? 0);
        state = state.set('voiceover_tab_duration', action.payload.voiceover ?? 0);
        state = state.set('original_content_tab_duration', action.payload.original_content ?? 0);
        time_tracker.clear();
        return state;
    }
    // update the stored time on explicit request (syncDurationForTab) or when switching tabs (switchEditorTab)
    if (syncDurationForTab.match(action)) {
        // get the time that's passed & reset the tracker
        const secondsPassed = time_tracker.getSecondsPassed();
        time_tracker.clear();

        // update the relevant store
        switch (action.payload.currentTab) {
            case EDITOR_TAB_OPTIONS.MEDIA:
                return state.set(
                    'media_tab_duration',
                    state.get('media_tab_duration') + secondsPassed,
                );
            case EDITOR_TAB_OPTIONS.MUSIC:
                return state.set(
                    'music_tab_duration',
                    state.get('music_tab_duration') + secondsPassed,
                );
            case EDITOR_TAB_OPTIONS.STYLE:
                return state.set(
                    'style_tab_duration',
                    state.get('style_tab_duration') + secondsPassed,
                );
            case EDITOR_TAB_OPTIONS.FORMAT:
                return state.set(
                    'format_tab_duration',
                    state.get('format_tab_duration') + secondsPassed,
                );
            case EDITOR_TAB_OPTIONS.ICONS:
                return state.set(
                    'icons_tab_duration',
                    state.get('icons_tab_duration') + secondsPassed,
                );
            case EDITOR_TAB_OPTIONS.VOICEOVER:
                return state.set(
                    'voiceover_tab_duration',
                    state.get('voiceover_tab_duration') + secondsPassed,
                );
            case EDITOR_TAB_OPTIONS.ORIGINAL_CONTENT:
                return state.set(
                    'original_content_tab_duration',
                    state.get('original_content_tab_duration') + secondsPassed,
                );
            default:
                return state;
        }
    }
    return state;
}

// now we combine the reducers into their final shape
export const analytics = combineReducers({
    tab_durations,
});

export type AnalyticsState = ReturnType<typeof analytics>;
